var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOutMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.994,
    height: 52.994,
    viewBox: "0 0 52.994 52.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187",
    transform: "translate(0 -61.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M4,61.272H48.994a4,4,0,0,1,4,4v44.994a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V65.272a4,4,0,0,1,4-4",
    fill: "#001233"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 30.816,
    transform: "translate(11.386 88.065)",
    fill: "none",
    stroke: "#f8f3ff",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutMap);
export default __webpack_public_path__ + "static/media/zoom-out-map.2f311a15e37439e33733142727d370f3.svg";
export { ForwardRef as ReactComponent };